import React from 'react';
import { 
  Grid, 
  Paper, 
  Typography, 
  Button,
  Box
} from '@mui/material';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import SchoolIcon from '@mui/icons-material/School';
import AutoStoriesIcon from '@mui/icons-material/AutoStories';
import UpdateIcon from '@mui/icons-material/Update';

const OrderTypeSelector = ({ onSelect }) => {
  return (
    <Box sx={{ py: 2 }}>
      <Typography variant="h6" gutterBottom>
        Select Order Type
      </Typography>
      
      <Grid container spacing={3}>
        {/* Advertising Order Option */}
        <Grid item xs={12} md={3}>
          <Paper
            elevation={3}
            sx={{
              p: 3,
              textAlign: 'center',
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              cursor: 'pointer',
              transition: 'transform 0.2s',
              '&:hover': {
                transform: 'scale(1.02)',
                boxShadow: 6
              }
            }}
            onClick={() => onSelect('ad')}
          >
            <Box>
              <ShoppingCartIcon sx={{ fontSize: 60, color: 'primary.main', mb: 2 }} />
              <Typography variant="h6" gutterBottom>
                Advertising Order
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Create a new advertising order for marketing and promotional campaigns
              </Typography>
            </Box>
            <Button 
              variant="contained" 
              sx={{ mt: 2 }}
              onClick={(e) => {
                e.stopPropagation();
                onSelect('ad');
              }}
            >
              Select
            </Button>
          </Paper>
        </Grid>
        
        {/* School Order Option */}
        <Grid item xs={12} md={3}>
          <Paper
            elevation={3}
            sx={{
              p: 3,
              textAlign: 'center',
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              cursor: 'pointer',
              transition: 'transform 0.2s',
              '&:hover': {
                transform: 'scale(1.02)',
                boxShadow: 6
              }
            }}
            onClick={() => onSelect('school')}
          >
            <Box>
              <SchoolIcon sx={{ fontSize: 60, color: 'success.main', mb: 2 }} />
              <Typography variant="h6" gutterBottom>
                School Order
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Create a new school order for educational institutions
              </Typography>
            </Box>
            <Button 
              variant="contained" 
              color="success"
              sx={{ mt: 2 }}
              onClick={(e) => {
                e.stopPropagation();
                onSelect('school');
              }}
            >
              Select
            </Button>
          </Paper>
        </Grid>
        
        {/* Stationery Order Option */}
        <Grid item xs={12} md={3}>
          <Paper
            elevation={3}
            sx={{
              p: 3,
              textAlign: 'center',
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              cursor: 'pointer',
              transition: 'transform 0.2s',
              '&:hover': {
                transform: 'scale(1.02)',
                boxShadow: 6
              }
            }}
            onClick={() => onSelect('stationery')}
          >
            <Box>
              <AutoStoriesIcon sx={{ fontSize: 60, color: 'warning.main', mb: 2 }} />
              <Typography variant="h6" gutterBottom>
                Stationery Order
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Create a new order for stationery and office supplies
              </Typography>
            </Box>
            <Button 
              variant="contained" 
              color="warning"
              sx={{ mt: 2 }}
              onClick={(e) => {
                e.stopPropagation();
                onSelect('stationery');
              }}
            >
              Select
            </Button>
          </Paper>
        </Grid>
        
        {/* Update Order Option */}
        <Grid item xs={12} md={3}>
          <Paper
            elevation={3}
            sx={{
              p: 3,
              textAlign: 'center',
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              cursor: 'pointer',
              transition: 'transform 0.2s',
              '&:hover': {
                transform: 'scale(1.02)',
                boxShadow: 6
              }
            }}
            onClick={() => onSelect('update')}
          >
            <Box>
              <UpdateIcon sx={{ fontSize: 60, color: 'info.main', mb: 2 }} />
              <Typography variant="h6" gutterBottom>
                Update Order
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Create a header update or modify an existing order
              </Typography>
            </Box>
            <Button 
              variant="contained" 
              color="info"
              sx={{ mt: 2 }}
              onClick={(e) => {
                e.stopPropagation();
                onSelect('update');
              }}
            >
              Select
            </Button>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default OrderTypeSelector; 